import config from "@/config";

export default new window.LodgeCompliance({
    env: config.app.env,
})